// extracted by mini-css-extract-plugin
module.exports = {"timeSelect":"BIBiK","skills":"Hddca","overdue":"Bc9MC","selectDescription":"FdBqn"};